/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteTenantRequest = {
  /**
   * The ID of the tenant. Required when using AdminApiKey authentication.
   */
  tenantId: string;
};

/** @internal */
export const DeleteTenantRequest$inboundSchema: z.ZodType<
  DeleteTenantRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tenant_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "tenant_id": "tenantId",
  });
});
/** @internal */
export type DeleteTenantRequest$Outbound = {
  tenant_id: string;
};

/** @internal */
export const DeleteTenantRequest$outboundSchema: z.ZodType<
  DeleteTenantRequest$Outbound,
  z.ZodTypeDef,
  DeleteTenantRequest
> = z.object({
  tenantId: z.string(),
}).transform((v) => {
  return remap$(v, {
    tenantId: "tenant_id",
  });
});

export function deleteTenantRequestToJSON(
  deleteTenantRequest: DeleteTenantRequest,
): string {
  return JSON.stringify(
    DeleteTenantRequest$outboundSchema.parse(deleteTenantRequest),
  );
}
export function deleteTenantRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTenantRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteTenantRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTenantRequest' from JSON`,
  );
}
